import React from "react";

const CompetitorsAnalysis = () => {
  return <div>COMPETITORS ANALYSIS PAGE</div>;
};

export default CompetitorsAnalysis;
